import api from "./api";

export const fetchAuditLogs = (params = {}) => api.get("/audit-logs/", { params });

export const fetchAuditLogDetail = (id) => api.get(`/audit-logs/${id}/`);

export const fetchAuditEntityHistory = (entityType, entityId) =>
  api.get(`/audit/entity/${encodeURIComponent(entityType)}/${encodeURIComponent(entityId)}/`);

export const fetchAuditSummary = (params = {}) => api.get("/audit-summary/", { params });

export const exportAuditLogsCsv = (params = {}) =>
  api.get("/audit-logs/export/", { params, responseType: "blob" });

export function unwrapAuditList(data) {
  if (Array.isArray(data)) return { rows: data, count: data.length };
  if (data?.results) return { rows: data.results, count: data.count ?? data.results.length };
  return { rows: [], count: 0 };
}
